import { useTranslator } from '@gandi/translate';
import { createValidate } from '../models/validate';
export function useValidate(initialTemplate) {
  const {
    __
  } = useTranslator();
  let options;
  if (initialTemplate) {
    // When sharing_space of a template is void, it means it is a public orga.
    // It's considered as a non-editable templates so we have to bypass the sharingId check
    options = {
      ignoreSharingId: initialTemplate.editable === false
    };
  }
  return createValidate(__, options);
}